import { ChangeEvent } from "react";
import { CHAT_FILE_ACCEPTED_TYPES } from "duck/ui/chat/constants";
import { validateChatAttachment } from "duck/ui/chat/utils";
import { useTranslation } from "react-i18next";
import AddIcon from "@mui/icons-material/Add";
import Box from "@mui/material/Box";

import IconButton from "features/components/IconButton";
import { toast } from "features/ui/Toast";

interface ChatFileUploadProps {
  onSelect: (files: File[]) => void;
}

const ChatFileUpload = ({ onSelect }: ChatFileUploadProps) => {
  const { t } = useTranslation("duck");

  const handleChange = (event: ChangeEvent<HTMLInputElement>) => {
    const selectedFiles = Array.from(event.target.files ?? []);
    if (!selectedFiles.length) return;

    const validFiles = selectedFiles.filter((selectedFile) => {
      const validation = validateChatAttachment(selectedFile);
      if (!validation.isValid) {
        toast.error(t(validation.errorKey!));

        return false;
      }

      return true;
    });

    if (validFiles.length) {
      onSelect(validFiles);
    }

    event.target.value = "";
  };

  return (
    <Box className="flex items-end">
      <label className="flex items-center">
        <input
          type="file"
          className="hidden"
          accept={CHAT_FILE_ACCEPTED_TYPES}
          multiple
          onChange={handleChange}
        />
        <IconButton
          color="secondary"
          size="small"
          aria-label={t("common:upload_file")}
          data-testid="duck-file-upload-button"
          tooltip={t("attach_files_instructions")}
          component="span"
        >
          <AddIcon fontSize="small" />
        </IconButton>
      </label>
    </Box>
  );
};

export default ChatFileUpload;
